import { memo, useRef } from "react";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import { Modal } from "react-bootstrap";

const CustomPhoto = ({
  rotation,
  setRotation,
  imgsrc,
  isZommImage,
  setisZommImage,
}) => {
  const imageRef = useRef(null);

  const handleRotate = (degrees) => {
    const finalRotation = (rotation + degrees) % 360;
    setTimeout(() => {
      setRotation(finalRotation);
    }, 200);
  };

  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
        <div class="text-center p-3 zoomimg-container" >
            <span className="me-4" style={{ color: 'white' }} onClick={() => zoomIn()}>  <i className='fa-solid fa-magnifying-glass-plus p-1' alt="Zoom In"></i> Zoom In</span>
            <span className="me-4" style={{ color: 'white' }} onClick={() => zoomOut()}> <i className='fa-solid fa-magnifying-glass-minus p-1' alt="Zoom Out"></i> Zoom Out</span>
            <span className="me-4" style={{ color: 'white' }} onClick={() => { resetTransform(); setRotation(0) }}> <i className='fa-solid fa-arrows-rotate p-1' alt="Reset"></i> Reset</span>

            <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(90)}> <i className='fa-solid fa-rotate-right' alt="Rotate 90 Degree"></i></span>

            <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(180)}>  <i className="fa-solid fa-repeat" alt="Rotate 180 Degree"></i></span>

            <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(-90)}>   <i className='fa-solid fa-rotate-left' alt="Rotate 270 Degree"></i></span>

            <span className="me-4" style={{ color: 'white' }} onClick={() => {setisZommImage(false); setRotation(0)} }>   <i className='fa-solid fa-xmark p-1' alt="Close"></i> Close</span>

        </div>
    );
};

  const ZoomImageComponent = () => {
    return (
      <TransformWrapper>
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <>
            <Controls />
            <TransformComponent>
              <div className="Zoomimage-container">
                <img
                  onClick={() => {
                    setisZommImage(true);
                  }}
                  ref={imageRef}
                  src={imgsrc}
                  alt="Base64"
                  className="responsive-image"
                  style={{ transform: `rotate(${rotation}deg)` }}
                  // style={{
                  //   transform: `rotate(${rotation}deg)`,
                  //   height: "100%",
                  //   objectFit: "contain", // Ensures the full image is displayed
                  //   marginTop: "0", // Adjust margin if needed
                  //   maxHeight: "80vh",
                  //   minHeight: "80vh",
                  //   minWidth: "80vh",
                  //   maxWidth: "80vh",
                  // }}
                />
              </div>
            </TransformComponent>
          </>
        )}
      </TransformWrapper>
    );
  };

  return (
    <div>
      <Modal
        show={isZommImage}
        size="xl"
        onHide={() => setisZommImage(false)}
        centered
      >
        <Modal.Body
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            backgroundColor: "rgb(0 1 14 / 50%)",
            height: "100%",
          }}
        >
          <ZoomImageComponent />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default memo(CustomPhoto);
